(function () {

    /*
    * Ottimizzazione riproduzione multi-video
    * */

    // Flag globali (calcolati una volta)
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const prefersReducedData   = window.matchMedia?.('(prefers-reduced-data: reduce)').matches === true;
    const saveData             = (navigator.connection && navigator.connection.saveData) === true;

    // Se l'utente non vuole movimento o vuole risparmiare dati: non carichiamo i video
    if (prefersReducedMotion || prefersReducedData || saveData) {
        // Lascia i poster e non idratare le sorgenti
        return;
    }

    // Selettore per tutti i video da gestire
    const videos = Array.from(document.querySelectorAll('video[data-autoplay-video]'));
    if (!videos.length) return;

    // Utility: prepara il video per l'autoplay inline su iOS/Safari
    const primeForAutoplay = (v) => {
        v.muted = true;           // richiesto per autoplay
        v.defaultMuted = true;    // aiuta Safari
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
    };

    // Utility: idrata le <source> data-src => src una sola volta
    const hydrateSources = (v) => {
        if (v.__hydrated) return;
        const sources = v.querySelectorAll('source[data-src]');
        sources.forEach(s => {
            if (!s.src) s.src = s.getAttribute('data-src');
            s.removeAttribute('data-src');
        });
        v.__hydrated = true;
        v.load();
    };

    // Utility: tenta il play con retry "gentile"
    const tryPlay = (v) => {
        const p = v.play();
        if (p && typeof p.catch === 'function') {
            p.catch(() => {
                setTimeout(() => v.play().catch(()=>{}), 80);
            });
        }
    };

    // Prepara tutti i video
    videos.forEach(primeForAutoplay);

    // Un solo IntersectionObserver per tutti i video
    const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
            const v = e.target;

            if (e.isIntersecting) {
                // Entra in viewport: idrata (lazy) e avvia
                hydrateSources(v);
                tryPlay(v);
            } else {
                // Esce dal viewport: opzionale — metti in pausa per risparmiare risorse
                // Commenta la riga sotto se vuoi che continuino a loopare anche fuori schermo
                v.pause();
            }
        }
    }, { rootMargin: '200px 0px', threshold: 0.1 });

    videos.forEach(v => io.observe(v));

    // Se alcune sorgenti sono già presenti (es. <link rel="preload"> ha fatto il suo),
    // prova comunque a far partire i video già idratati che sono in viewport.
    const kickVisibleAlreadyHydrated = () => {
        videos.forEach(v => {
            const hasRealSource = !!v.querySelector('source:not([data-src])');
            if (hasRealSource && isElementInViewport(v)) {
                tryPlay(v);
            }
        });
    };

    const isElementInViewport = (el) => {
        const r = el.getBoundingClientRect();
        return r.bottom > 0 && r.right > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight) && r.left < (window.innerWidth || document.documentElement.clientWidth);
    };

    kickVisibleAlreadyHydrated();

    // Riprendi il loop al ritorno dalla bfcache
    window.addEventListener('pageshow', (e) => {
        if (e.persisted) {
            videos.forEach(v => {
                if (isElementInViewport(v)) tryPlay(v);
            });
        }
    });

    // Pausa quando la scheda è nascosta (risparmio batteria)
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            videos.forEach(v => v.pause());
        } else {
            videos.forEach(v => {
                if (isElementInViewport(v)) tryPlay(v);
            });
        }
    }, false);



    /*
    * Se l’utente ha “reduce” o se, per qualsiasi ragione,
    * il tuo IIFE non idrata/avvia l’hero,
    * questa piccola funzione di fallback si occupa solo dell’hero
    * */

    // Isola il blocco per il hero per maggiore sicurezza (blocchi con nomi unici)
    {
        const hero = document.getElementById('heroVideo');
        if (!hero) {
            // non esiste hero: esci dal blocco senza errori
        } else {

            // Forza i prerequisiti per autoplay inline
            hero.muted = true;
            hero.defaultMuted = true;
            hero.setAttribute('muted', '');
            hero.setAttribute('playsinline', '');
            hero.setAttribute('webkit-playsinline', '');

            // Idrazione sorgenti solo se mancano ancora (compatibile col tuo hydrate)
            const hydrateHero = () => {
                if (hero.__hydrated) return;
                const sources = hero.querySelectorAll('source[data-src]');
                let changed = false;
                sources.forEach(s => {
                    if (!s.getAttribute('src')) {
                        s.setAttribute('src', s.getAttribute('data-src'));
                        s.removeAttribute('data-src');
                        changed = true;
                    }
                });
                if (changed) {
                    hero.__hydrated = true;
                    hero.load();
                }
            };

            // Play “gentile” con retry (nome univoco per evitare collisioni)
            const tryPlayHero = () => {
                const p = hero.play();
                if (p && typeof p.catch === 'function') {
                    p.catch(() => setTimeout(() => hero.play().catch(()=>{}), 80));
                }
            };

            // Se il video è (o sta per essere) in viewport, idrata e avvia
            const kickstartHero = () => {
                hydrateHero();
                tryPlayHero();
            };

            // Avvio immediato se l’hero è above-the-fold
            if (isInViewport(hero)) {
                kickstartHero();
            } else if ('IntersectionObserver' in window) {
                // In caso raro di hero sotto la fold (responsive), usa IO locale con nome differente
                const heroIo = new IntersectionObserver((entries) => {
                    if (entries.some(e => e.isIntersecting)) {
                        kickstartHero();
                        heroIo.disconnect();
                    }
                }, { rootMargin: '200px 0px', threshold: 0.1 });
                heroIo.observe(hero);
            } else {
                kickstartHero();
            }

            // Riparte quando si torna dalla bfcache
            window.addEventListener('pageshow', e => { if (e.persisted && isInViewport(hero)) tryPlayHero(); });

            // Se la scheda torna visibile e l’hero è visibile, riprova
            document.addEventListener('visibilitychange', () => {
                if (!document.hidden && isInViewport(hero)) tryPlayHero();
            });
        }

        function isInViewport(el) {
            const r = el.getBoundingClientRect();
            return r.bottom > 0 && r.right > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight) && r.left < (window.innerWidth || document.documentElement.clientWidth);
        }
    }
})();
